:host {
  display: block;
  font-family: "Visa Dialect", sans-serif;
}

.vs-promotout-container-light {
  --promotout-bg: #ffffff;
  --promotout-left-bg-white: #ffffff;
  --promotout-left-bg-grey: #f7f7f7;
  --promotout-bg-white: #ffffff;
  --promotout-bg-grey: #f7f7f7;
  --parent-bg: transparent;
  --text-color: #1a1a1a;
  --text-color-desc: #656565;
}

.vs-promotout-container-dark {
  --promotout-bg: #1a1a1a;
  --promotout-left-bg-white: #1a1a1a;
  --promotout-left-bg-grey: #2c2c2c;
  --promotout-bg-white: #1a1a1a;
  --promotout-bg-grey: #2c2c2c;
  --parent-bg: transparent;
  --text-color: #ffffff;
  --text-color-desc: #ffffff;
}

.vs-promotout-container.variant2 {
  padding: 0;
  @media (min-width: 768px) {
    padding: 0;
  }
  & .vs-promotout-content-wrapper {
    align-items: flex-start;
  }
  & .vs-promotout-content-wrapper-title {
    padding: 24px 24px 48px 24px;
    width: auto;
    @media (min-width: 768px) {
      padding: 0px 0px 0px 48px;
      max-width: none;
      margin: 0;
      width: 460px;
    }
  }
}
.vs-promotout-container {
  display: flex;
  align-items: stretch;
  padding: 24px;
  max-width: 1600px;
  margin: 0 auto;

  @media (min-width: 1440px) {
    padding: 48px;
  }
}

.vs-promotout-container.media-left {
  flex-direction: column-reverse;
  @media (min-width: 768px) {
    flex-direction: row;
  }
}

.vs-promotout-container.media-right {
  flex-direction: column;
  @media (min-width: 768px) {
    flex-direction: row;
  }
}

.vs-promotout-content-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-basis: 50%;
  padding: 48px 32px;
}

.vs-promotout-content-wrapper.white {
  background-color: var(--promotout-left-bg-white);
}

.vs-promotout-content-wrapper.grey {
  background-color: var(--promotout-left-bg-grey);
}

.vs-promotout-content-wrapper-title {
  max-width: 512px;
  margin: 0 auto;
}

.vs-promotout-image-container {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  height: auto;
  background-position: center center;
  aspect-ratio: 4/3;
  background-size: cover;
  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background-image: var(--vsr-image-poster);
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    z-index: 0;
  }
}

.vs-promotout-video-container {
  height: auto;
  background-position: center center;
  aspect-ratio: 4/3;
  background-size: cover;
}

.vs-promotout-content-wrapper,
.vs-promotout-image-container,
.vs-promotout-video-container {
  flex: 0 0 50%;
  max-width: none;
  @media (min-width: 768px) {
    max-width: 50%;
    max-height: 605px;
  }
}

.vs-promotout-content-wrapper-left vsr-title {
  --vsr-title-bg: var(--parent-bg);
}

@media (max-width: 768px) {
  .vs-promotout-container vsr-title .vsr-title-headline {
    font-size: 32px; /* Mobile font size */
  }
}

@media (min-width: 768px) {
  .vs-promotout-container vsr-title .vsr-title-container.horizontal .vsr-title-button-group {
    padding-top: 16px;
  }
}
